
const data = {
  data: [
    {
      id: 10,
      name: 'cliente@adarsa.es',
      surname: '12345678A',
      status_id: 0,
      lang_code: 'es',
      email: 'cliente@adarsa.es',
      email_verified_at: null,
      birthday_date: '1962-12-21',
      created_at: '2021-06-10T10:27:36.000000Z',
      updated_at: '2021-06-10T10:27:36.000000Z',
      deleted_at: null,
      cifnif: null
    },
    {
      id: 13,
      name: 'cliente2@adarsa.es',
      surname: 'B32293748',
      status_id: 0,
      lang_code: 'es',
      email: 'cliente2@adarsa.es',
      email_verified_at: null,
      birthday_date: '2003-06-03',
      created_at: '2021-06-10T10:57:40.000000Z',
      updated_at: '2021-06-10T10:57:40.000000Z',
      deleted_at: null,
      cifnif: null
    },
    {
      id: 14,
      name: 'cliente4@adarsa.es',
      surname: 'B32293748',
      status_id: 0,
      lang_code: 'es',
      email: 'cliente4@adarsa.es',
      email_verified_at: null,
      birthday_date: '2003-06-03',
      created_at: '2021-06-10T10:58:02.000000Z',
      updated_at: '2021-06-10T10:58:02.000000Z',
      deleted_at: null,
      cifnif: null
    },
    {
      id: 17,
      name: '',
      surname: 'jorge',
      status_id: 0,
      lang_code: 'es',
      email: 'jorge.dedios@simbiosys.esasdfasdfasfdafafd',
      email_verified_at: null,
      birthday_date: '2003-06-03',
      created_at: '2021-06-10T11:18:58.000000Z',
      updated_at: '2021-06-10T11:18:58.000000Z',
      deleted_at: null,
      cifnif: null
    },
    {
      id: 18,
      name: '',
      surname: 'jorged',
      status_id: 0,
      lang_code: 'es',
      email: 'aaaa@bbb.es',
      email_verified_at: null,
      birthday_date: '2003-06-03',
      created_at: '2021-06-11T11:19:15.000000Z',
      updated_at: '2021-06-11T11:19:15.000000Z',
      deleted_at: null,
      cifnif: null
    },
    {
      id: 19,
      name: 'test3',
      surname: 'test 23',
      status_id: 0,
      lang_code: 'es',
      email: 'jorges.dedios@simbiosys.es',
      email_verified_at: null,
      birthday_date: '2003-06-03',
      created_at: '2021-06-11T11:20:25.000000Z',
      updated_at: '2021-08-26T07:40:26.000000Z',
      deleted_at: null,
      cifnif: 'B32293748'
    },
    {
      id: 25,
      name: '',
      surname: 'ddp',
      status_id: 0,
      lang_code: 'es',
      email: 'cufa@simbiosys.es',
      email_verified_at: null,
      birthday_date: null,
      created_at: '2021-09-20T11:04:31.000000Z',
      updated_at: '2021-09-20T11:04:31.000000Z',
      deleted_at: null,
      cifnif: 'B32293748'
    }
  ],
  links: {
    first: 'http://localhost/api/v1/clients?page=1',
    last: 'http://localhost/api/v1/clients?page=8',
    prev: null,
    next: null
  },
  meta: {
    current_page: 2,
    from: 1,
    last_page: 8,
    links: [
      {
        url: 'http://localhost/api/v1/clients?page=1',
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/clients?page=2',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/clients?page=3',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/clients',
    per_page: 10,
    to: 20,
    total: 80
  }
}

export default data
